import { fractionFormat } from '@/util-conversion/currency/currency-to-string';

// returns the price as a number with 2 decimal places
export const getFloatCurrency = (price: number): number => {
  return parseFloat(fractionFormat(price).substring(1));
};
